import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
// import axios from "axios";
import React, { useEffect, useState } from "react";
import { OrgType } from "./DialogOrgTable";
import Waveform from "../../../component/common/waveSurfer/WaveForm.js";
import api from "../../../../API";
import { useSelector } from "react-redux";

interface rejectProps {
  email: string;
  col_pk: string;
  setDelayPageOpen: React.Dispatch<React.SetStateAction<boolean>>
  setOpen:React.Dispatch<React.SetStateAction<boolean>>;
  getOrgList:any;
  p_order:any;
  p_isp_yn:any;
  p_vn_yn:any;
  p_worker:any;
}

// const SampleRejectRsnDialog = () => {
const OrgDelayRsnDialog = (props: rejectProps) => {

  const [reject_rsn , setReject_rsn] = useState("");

  const auth = useSelector((state:any)=> state.userInfo.data)
  // console.log('auth.user',auth.user)
  const isp_email = auth.user.email;

  const orgDelay = async () => {

    // console.log(props.email, props.col_pk, reject_rsn)

    const formData = new FormData();

    formData.append("email", isp_email);
    formData.append("col_pk", props.col_pk);
    formData.append("isp_email", isp_email);
    formData.append("isp_yn", "D");

    formData.append("reject_rsn", reject_rsn);

    

    // return;

    // var result = await api.post("/sampleConfirm",{"email":data.email,"role":selectedAuth,"new_file_name":data.new_file_name});

    // console.log('sampleConfirm result',result)
    await api.post("/nvSttSrtReject",formData)
    .then((res:any) => { alert("수집 데이터 보류 처리가 완료되었습니다. 사유: " + reject_rsn); props.setOpen(false); props.getOrgList(props.p_order,props.p_isp_yn,props.p_vn_yn,props.p_worker); })
    .catch((error:any) => {alert('오류 - '+ error.response.data.error);})

  }
  

  return (
    <Box >
    <Dialog maxWidth="md" open={true} fullWidth={true}>
      <DialogTitle sx={{padding: "16px 24px 0px 24px"}}>
        <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>수집 보류사유 작성</Box>
        <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
      </DialogTitle>
      <DialogContent dividers>

        <Box display="flex">
          <Box sx={{width:"100%", margin:"8px"}}>
            <Box m={1} display="flex" sx={{alignItems:"center"}}>
              <Box sx={{fontWeight:700, marginBottom:"4px", width:"120px"}}>보류사유</Box>
              <TextField
                value={reject_rsn}
                variant="standard"
                multiline
                fullWidth
                maxRows={4}
                sx={{marginLeft:"8px", marginRight:"58px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setReject_rsn(event.target.value);
                }}
              />
              
            </Box>
          </Box>
        </Box>
        {/* </form> */}
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="secondary" sx={{fontWeight:700, margin:"8px 16px"}}
          onClick={() => {
            props.setDelayPageOpen(false);
          }}
        >
          취소
        </Button>
        <Button variant="contained" color="error" sx={{fontWeight:700, margin:"8px 16px"}}
          onClick={() => {
            orgDelay();
          }}
        >
          보류처리
        </Button>
      </DialogActions>
    </Dialog>
    </Box>
  );
};

export default OrgDelayRsnDialog;
